import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDiamondShine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDiamondShine"><Path d="M16.5 7.5H7.5L3.5 12.5L12 21.5L20.5 12.5L16.5 7.5Z" stroke="currentColor"/><Path d="M4 12.5H20" stroke="currentColor" strokeLinecap="square"/><Path d="M12 2.5V4.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21 4L19.5 5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3 4L4.5 5.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDiamondShine;
